import React from 'react';
import { useLocation } from 'react-router-dom';
import { PageForm } from '/src/layouts/page';
import DatasetForm from '../../features/dataset/components/form/DatasetForm/DatasetForm';
import QuotePart from '/src/components/quote/QuotePart';

function DatasetUpdate() {
    const location = useLocation();

    return (

        <PageForm>
            <DatasetForm data={location.state.data} type='update'/>
            <QuotePart />
        </PageForm>

    );
}
export default DatasetUpdate;